export default __webpack_public_path__ + "static/media/woman-meditating-with-night-hair.d26e8a16.svg";